import UploadSchoolLogo from './UploadSchoolLogo.component';

export default UploadSchoolLogo;